import { z } from "zod";

export const hotelSearchSchema = z
  .object({
    location: z
      .object({
        value: z.string(),
        label: z.string(),
      })
      .nullable()
      .refine((city) => city !== null, {
        message: "Lokasyon alanı boş olamaz",
      }),
  })

export default hotelSearchSchema;
